import { createI18n } from 'vue-i18n'
import en from './en'
import ru from './ru'

const saved = localStorage.getItem('gamepay_locale') || 'en'

const i18n = createI18n({
  legacy: false,
  locale: saved,
  fallbackLocale: 'en',
  messages: { en, ru },
})

export default i18n
